const lang_id = {
    // Navigations
    "home": "Beranda",
    "map": "Peta",
    "about": "Tentang kami",
    "contact": "Hubungi kami",

    // Hero (Home)
    "title_1" : "Sistem Informasi Geografis ",
    "title_2" : "dan masih banyak lagi.",
    "subtitle" : "Didedikasikan dari warga Agrabinta, oleh warga Agrabinta, untuk warga Agrabinta.",
    "go_to_map": "Lihat peta",

    // Map

    // About

    // Contact
}

export default lang_id;